const breakpoints = {
  xxl: 1512,
  xl: 1200,
  lg: 992,
  md: 768,
  sm: 576,
};

export default breakpoints;
